import { GET_DRIVERS_REVENUES_API, GET_FLEET_REVENUES_API } from "../utils/api";
import { handleError } from "../utils/errorUtils";

export const LOAD_DRIVERS_REVENUES_REQUEST =
  "@revenue/LOAD_DRIVERS_REVENUES_REQUEST";
export const LOAD_FLEET_REVENUES_REQUEST =
  "@revenue/LOAD_FLEET_REVENUES_REQUEST";
export const RESET_TRIP_REQUEST = "@revenue/RESET_TRIP_REQUEST";
export type DRIVERS_REVENUES_REQUEST = typeof LOAD_DRIVERS_REVENUES_REQUEST;
export type FLEET_REVENUES_REQUEST = typeof LOAD_FLEET_REVENUES_REQUEST;

interface IDriversRevenues {
  data: any;
  total: number;
}

export interface LoadDriversRevenues {
  type: DRIVERS_REVENUES_REQUEST;
  payload: {
    drivers: IDriversRevenues | null;
    error: string | null;
  };
}

export interface LoadFleetRevenues {
  type: FLEET_REVENUES_REQUEST;
  payload: {
    revenues: number | null;
    error: string | null;
  };
}

interface IFilters {
  page: number;
  limit: number;
  driver?: string;
}

export async function loadDriversRevenues(
  filters: IFilters
): Promise<LoadDriversRevenues> {
  try {
    const response = await GET_DRIVERS_REVENUES_API(filters);
    const { pagination, list } = response.data.data;
    return {
      type: LOAD_DRIVERS_REVENUES_REQUEST,
      payload: {
        drivers: {
          data: list,
          total: pagination.total,
        },
        error: null,
      },
    };
  } catch (error) {
    const errorMessage = handleError(error);
    return {
      type: LOAD_DRIVERS_REVENUES_REQUEST,
      payload: {
        drivers: null,
        error: errorMessage,
      },
    };
  }
}

export async function loadFleetRevenues(
  date: string
): Promise<LoadFleetRevenues> {
  try {
    const response = await GET_FLEET_REVENUES_API({ date });
    const { totalBenefit } = response.data.data;
    return {
      type: LOAD_FLEET_REVENUES_REQUEST,
      payload: {
        revenues: totalBenefit ?? 0,
        error: null,
      },
    };
  } catch (error) {
    const errorMessage = handleError(error);
    return {
      type: LOAD_FLEET_REVENUES_REQUEST,
      payload: {
        revenues: null,
        error: errorMessage,
      },
    };
  }
}
